<template>
  <v-layout
    v-if="user"
    row
    align-center
  >
    <v-flex
      xs12
      sm10
      offset-sm1
      md10
      offset-md1
      lg10
      offset-lg1
      xl8
      offset-xl2
    >
      <v-card
        flat
        :color="theme.bg_color"
      >
        <v-card-text>
          <v-layout
            row
            align-center
            ma-3
          >
            <v-flex xs3>
              <v-avatar
                slot="activator"
                size="60"
              >
                <img :src="myImg">
              </v-avatar>
            </v-flex>
            <v-flex
              xs9
              pl-3
            >
              <page-title :title="$t('profile')" />
            </v-flex>
          </v-layout>
          <progress-bar :show="busy"></progress-bar>
          <v-divider class="mt-1 mb-1" :color="theme.orders_divider_color" />
          <div>
            <v-layout
              row
              align-center
              mb-2
            >
              <v-flex xs5
                      sm3
                      md3
                      lg2
                      xl2
              >Name: </v-flex>
              <v-flex xs7
                      sm9
                      md9
                      lg10
                      xl10
              >{{ user.name }} {{ user.name2 }}</v-flex>
            </v-layout>
            <v-layout
              row
              align-center
              mb-2
            >
              <v-flex xs5
                      sm3
                      md3
                      lg2
                      xl2
              >Login Method: </v-flex>
              <v-flex xs7
                      sm9
                      md9
                      lg10
                      xl10
              >{{ loginMethod }}
                <v-btn
                  v-if="loginMethod === 'Email'"
                  small
                  :color="theme.btn_color_primary"
                  dark
                  @click="resetPassword"
                >reset password</v-btn>
              </v-flex>
            </v-layout>
            <v-layout
              row
              align-center
              mb-2
            >
              <v-flex xs5
                      sm3
                      md3
                      lg2
                      xl2
              >Membership: </v-flex>
              <v-flex xs7
                      sm9
                      md9
                      lg10
                      xl10
              >{{ membership.name }}</v-flex>
            </v-layout>
            <v-layout
              row
              align-center
              mb-2
              v-if="config.enable_member_points"
            >
              <v-flex xs5
                      sm3
                      md3
                      lg2
                      xl2
              >Points: </v-flex>
              <v-flex xs7
                      sm9
                      md9
                      lg10
                      xl10
              >{{ points }}</v-flex>
            </v-layout>
            <v-layout
              row
              align-center
              mb-2
              v-if="next_tier && (parseInt(next_tier.condition_type) === 2 || parseInt(next_tier.condition_type) === 3)"
            >
              <v-flex xs5
                      sm3
                      md3
                      lg2
                      xl2
              >{{ progressLabel }}: </v-flex>
              <v-flex xs7
                      sm9
                      md9
                      lg10
                      xl10
              >{{ getProgress }}</v-flex>
            </v-layout>
          </div>
          <v-divider class="mt-1 mb-1" :color="theme.orders_divider_color" />
          <membership-progress v-if="showMembershipProgress"></membership-progress>
<!--          <v-footer-->
<!--            fixed-->
<!--            app-->
<!--            inset-->
<!--            height="64px"-->
<!--          >-->
<!--            <v-btn-->
<!--              block-->
<!--              dark-->
<!--              large-->
<!--              class="btn"-->
<!--              :color="theme.btn_color_primary"-->
<!--              @click="save"-->
<!--            >-->
<!--              <v-layout row>-->
<!--                <v-flex-->
<!--                  xs12-->
<!--                  class="text-xs-center"-->
<!--                >-->
<!--                  {{ $t('save') }}-->
<!--                </v-flex>-->
<!--              </v-layout>-->
<!--            </v-btn>-->
<!--          </v-footer>-->
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import Form from 'vform'
import PageTitle from '~/components/PageTitle'
import MembershipProgress from '~/components/MembershipProgress'
import axios from 'axios'

export default {
  name: 'profile-view',
  metaInfo () {
    return { title: this.$t('profile') }
  },
  components: {
    'page-title': PageTitle,
    'membership-progress': MembershipProgress
  },
  data: () => ({
    busy: false,
    current_tier: null,
    next_tier: null,
  }),
  computed: {
    ...mapGetters('config', [
      'theme', 'pictures', 'colors', 'config'
    ]),
    ...mapGetters('auth', [
      'user'
    ]),
    ...mapGetters('member', [
      'points', 'profile', 'membership', 'membershipConfig'
    ]),
    defaultUserImg () {
      return this.pictures + 'user.svg'
    },
    myImg () {
      return this.user && this.user.photo ? this.user.photo : window.config.sharedPictures + 'user.svg'
    },
    form () {
      return new Form({
        name: this.user.name,
        name2: this.user.name2
      })
    },
    loginMethod () {
      return this.user.social ? this.user.social : 'Email'
    },
    getProgress() {
      switch (this.next_tier.condition_type) {
        case '2':
          return parseInt(this.next_tier.current_progress) > 0 ? '$' + this.next_tier.current_progress : '$ 0.00'
        case '3':
          return this.next_tier.current_progress
      }
    },
    progressLabel() {
      switch (this.next_tier.condition_type) {
        case '2':
          return 'Amount Spent'
        case '3':
          return 'Visit Count'
      }
    },
    showMembershipProgress() {
      return (parseInt(this.config.group_id) !== 533)
    }
  },
  methods: {
    async save () {
      if (await this.formHasErrors()) return
      this.busy = true

      try {
        // Register the user.
        await this.$store.dispatch('auth/updateProfile', this.form)
        this.busy = false
        this.$store.dispatch('responseMessage', {
          type: 'success',
          text: 'Changes to your profile were saved'
        })
      } catch (e) {
        this.busy = false
        this.$store.dispatch('responseMessage', {
          type: 'error',
          text: 'Failed to update user profile',
          modal: true
        })
      }
    },
    resetPassword () {
      this.$router.push({ name: 'password.request' })
    },
  },
  async beforeMount () {
    await axios.post('/api/membership/progress', {
      current_rate_id: this.membership.rate_id,
      member_id: this.membership.member_id,
    }).then(response => {
      this.current_tier = response.data.current_tier
      this.next_tier = response.data.next_tier
    })
  },
  async created () {
    await this.$store.dispatch('auth/fetchUser')
    await this.$store.dispatch('fetchMembershipInfo')
    const dict = {
      custom: {
        name: {
          required: 'Please enter your first name / given name'
        },
        name2: {
          required: 'Please enter your last name / family name'
        },
        mobile: {
          required: 'Please enter your mobile number'
        },
        birthday: {
          required: 'Please enter your birthday'
        }
      }
    }
    this.$validator.localize('en', dict)
  }
}
</script>

<style scoped>
.btn {
  margin: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/profile.vue